export const REFERENCE_PERIOD_SELECT_OPTIONS = [
  '2020',
  '2021',
  '2022',
  '2023',
  '2024',
  '2025',
  '2026',
  '2026 H1',
  '2027',
  '2028',
  '2029',
  '2030',
] as const

export function referencePeriodYear(period: string | number): number {
  const yearPart = String(period).trim().split(' ', 1)[0]
  const year = Number(yearPart)
  return Number.isFinite(year) ? year : 0
}

/** Quarterly/monthly sub-periods fall back to annual; half-year periods do not. */
export function hasQuarterlyOrMonthlyAnnualFallback(period: string): boolean {
  const parts = period.trim().split(' ', 2)
  if (parts.length < 2) return false
  const suffix = parts[1]
  return /^[QM]\d/.test(suffix)
}

export function compareReferencePeriods(
  a: string | number,
  b: string | number,
): number {
  const aStr = String(a)
  const bStr = String(b)
  const yearDiff = referencePeriodYear(a) - referencePeriodYear(b)
  if (yearDiff !== 0) return yearDiff

  const aHasSub = aStr.includes(' ')
  const bHasSub = bStr.includes(' ')
  if (!aHasSub && bHasSub) return -1
  if (aHasSub && !bHasSub) return 1
  return aStr.localeCompare(bStr)
}

export function sortReferencePeriods(
  periods: Array<string | number>,
): string[] {
  return [...new Set(periods.map((period) => String(period).trim()).filter(Boolean))]
    .sort(compareReferencePeriods)
}

export function latestReferencePeriodYear(periods: string[]): number {
  if (!periods.length) return new Date().getFullYear()
  return Math.max(...periods.map(referencePeriodYear))
}

export function referencePeriodSlotKey(period: string): string {
  return period.replace(/\s+/g, '-')
}

const asQueryArray = (value: unknown): string[] => {
  if (!value) return []
  if (Array.isArray(value)) return value.map((item) => String(item)).filter(Boolean)
  return String(value)
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
}

export function parseReferencePeriodsFromQuery(value: unknown): string[] {
  return sortReferencePeriods(
    asQueryArray(value).map((entry) => decodeURIComponent(entry)),
  )
}

export function encodeReferencePeriodsForQuery(periods: string[]): string {
  return periods.map((period) => encodeURIComponent(period)).join(',')
}
